import React from 'react';

const Feedback = () => (
  <p className="feedback font-lato text-align__center">
    {"We're always looking for ways to improve and would really appreciate your feedback. Please take this short "}
    <a href="https://www.surveymonkey.co.uk/r/QGTGQKS">survey</a>.
  </p>
);

export default Feedback;



// WEBPACK FOOTER //
// src/components/atoms/Feedback/index.jsx